import React from 'react';
import { Form } from 'react-bootstrap';

/**
 * Premium Form Field with custom styling and mandatory indicator
 */
const FormField = ({ 
  label, 
  error, 
  mandatory, 
  children, 
  className = "",
  containerClassName = "mb-3"
}) => {
  return (
    <Form.Group className={containerClassName}>
      {label && (
        <Form.Label className={`small font-weight-bold text-muted text-uppercase letter-spacing-1 ${mandatory ? 'label-mandatory' : ''}`}>
          {label}
        </Form.Label>
      )}
      <div className={`${error ? 'border border-danger rounded-lg overflow-hidden' : ''} ${className}`}>
        {children}
      </div>
      {error && typeof error === 'string' && <div className="text-danger small mt-1">{error}</div>}
    </Form.Group>
  );
};

export default FormField;
